module.exports = __webpack_public_path__ + "media/images/bg-03cb6aa8a378648a039eb869c8943b23.jpeg";